import type { Property } from "@tycho/web-bindings/types";
import { CompletedActionCard } from "@/web/routes/_protected/smb/-dashboard/-CompletedActionCard";
import type { SmbActionDefinition } from "@/web/routes/_protected/smb/-dashboard/-types";

type Props = {
  property: Property;
};

export function createInviteLandlordCompleted(props: Props & { id?: string }): SmbActionDefinition {
  const { property, id = `invite-landlord:done:${property.id.toString()}` } = props;
  return {
    id,
    category: "negotiate",
    canSkip: false,
    render: () => (
      <CompletedActionCard
        category="negotiate"
        badge="Price"
        title="Landlord invited"
        details={{
          title: "Landlord invited",
          children: (
            <div className="flex flex-col gap-2">
              <p className="font-medium">{property.address.addressLine1}</p>
              <p className="opacity-70">
                We've reached out to the landlord. They'll fill out a short form, and you'll see
                their answers as soon as they're back.
              </p>
            </div>
          ),
        }}
      />
    ),
  };
}
